import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TwxToastComponent } from './twx-toast.component';
import { TwxToastService } from './twx-toast.service';

/**
 * Where the panel's notifications appear: a fixed stack at the bottom right (full width
 * on a phone, at the top), newest nearest the corner, above drawers and modals. Rendered
 * once, in the app root.
 */
@Component({
    selector: 'twx-toaster',
    imports: [TwxToastComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'pointer-events-none fixed inset-x-4 top-4 z-[200] flex flex-col gap-2.5 sm:inset-auto sm:bottom-6 sm:right-6 sm:w-[372px] sm:flex-col-reverse',
        'aria-live': 'polite',
    },
    template: `
        @for (toast of toastS.toasts(); track toast.id) {
            <twx-toast [toast]="toast" (closed)="toastS.dismiss($event)" />
        }
    `,
})
export class TwxToasterComponent {
    protected readonly toastS = inject(TwxToastService);
}
